import React, { useMemo, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchInput from "../../components/SearchInput"; 
import { authFetch } from "../../utils/api";
import "../../styles/admin/aseguradoras.css"; 

export default function CorredorPublico() {
  const [q, setQ] = useState('');
  const [agencias, setAgencias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError(null);
    authFetch('/api/agencia/tipo/Corredor público')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Error al cargar corredores: ' + res.statusText);
        }
        return res.json();
      })
      .then((data) => {
        setAgencias(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setAgencias([]);
        setLoading(false);
      });
  }, []);

  const rows = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return agencias;
    return agencias.filter(r =>
      [r.nombre, r.telefono, r.correoElectronico, r.municipio, r.estado].some(v =>
        String(v).toLowerCase().includes(t)
      )
    );
  }, [q, agencias]);

  const handleAgregar = () => {
    navigate('/admin/corredorPublico/agregar');
  };

  const handleEditar = (corredor) => {
    navigate(`/admin/corredorPublico/editar/${corredor.id}`);
  };

  const handleDelete = async (corredor) => {
    const confirmacion = window.confirm(
      `¿Estás seguro de que deseas eliminar al corredor "${corredor.nombre}"?`
    );

    if (!confirmacion) {
      return;
    }

    try {
      const response = await authFetch(`/api/agencia/${corredor.id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('No se pudo eliminar el corredor.');
      }

      setAgencias(prevAgencias =>
        prevAgencias.filter(a => a.id !== corredor.id)
      );

      alert('Corredor eliminado exitosamente.');

    } catch (err) {
      alert(`Error al eliminar: ${err.message}`);
    }
  };


  return (
    <main className="aseg-main">
  

      <header className="aseg-header">
        <h1 className="aseg-title">Corredores</h1>
        <button className="aseg-btn" onClick={handleAgregar}>
          Agregar Corredor
        </button>
      </header>


      <SearchInput
        placeholder="Buscar por nombre, correo, teléfono, municipio..."
        value={q}
        onChange={setQ}
      />

      {loading && <p>Cargando corredores...</p>}

      {error && <p style={{ color: '#e11d48' }}>Error: {error}</p>}

      {!loading && !error && (
        <div className="aseg-card">
          {/* Wrapper para scroll horizontal */}
          <div className="aseg-table-wrapper">
            <table className="aseg-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Correo</th>
                  <th>Municipio</th>
                  <th>Estado</th>
                  <th className="col-acciones">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map(r => (
                    <tr key={r.id}>
                      <td>{r.nombre}</td>
                      <td>{r.telefono}</td>
                      <td className="td-email">{r.correoElectronico}</td>
                      <td>{r.municipio}</td>
                      <td>{r.estado}</td>

                      <td className="td-acciones">
                        <button
                          type="button"
                          className="aseg-link"
                          onClick={() => handleEditar(r)}
                        >
                          Editar
                        </button>
                        <button
                          type="button"
                          className="aseg-link"
                          style={{ marginLeft: '8px' }}
                          onClick={() => handleDelete(r)}
                        >
                          Borrar
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="aseg-empty">
                      No se encontraron corredores{q ? ' que coincidan con la búsqueda' : ''}.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </main>
  );
}